import React, { useState } from 'react';
import { Container, Row, Col, InputGroup, FormControl, Button } from 'react-bootstrap';

function WeightedScoreCalculator() {

    const [team1Score, setTeam1Score] = useState('');
    const [team1Wickets, setTeam1Wickets] = useState('');
    const [team1Overs, setTeam1Overs] = useState('');
    const [team2Score, setTeam2Score] = useState('');
    const [team2Wickets, setTeam2Wickets] = useState('');
    const [team2Overs, setTeam2Overs] = useState('');
    const [team1WS, setTeam1WS] = useState('');
    const [team2WS, setTeam2WS] = useState('');
    const [loading, setLoading] = useState(true);

    const handleClick = () => {
        if (!team1Score || !team1Wickets || !team1Overs || !team2Score || !team2Wickets || !team2Overs) {
            // Handle error
            return;
        }
        let t1 =
        {
            sc: team1Score,
            ov: team1Overs,
            wk: team1Wickets,
            pen: 0,
        };
        let t2 =
        {
            sc: team2Score,
            ov: team2Overs,
            wk: team2Wickets,
            pen: 0,
        };

        function numOver(ov, penOv) {
            return ov.includes('.') ? (parseInt(ov.split('.')[0]) + (parseInt(ov.split('.')[1]) / 6) + penOv) : parseInt(ov) + penOv;
        }
        var t1Over = numOver(t1.ov, t1.pen), t2Over = numOver(t2.ov, t2.pen);
        var team1WS = Math.pow(parseInt(t1.sc), 2) / (t1Over * (parseInt(t1.wk) || 1));
        var team2WS = Math.pow(parseInt(t2.sc), 2) / (t2Over * (parseInt(t2.wk) || 1));


        setTeam1WS(parseFloat(team1WS).toFixed(3));
        setTeam2WS(parseFloat(team2WS).toFixed(3));
        setLoading(false);
    };

    return (
        <Container className="bordered" id="content">
            <Row className='mb-2'>
                <Col xs={12} md={{ offset: 2, span: 8 }} >

                    <h1>Weighted Score calculator</h1>
                    <div id="target-calc-topbar" style={{ display: 'block', padding: '10px' }}>
                        <div>Team 1:</div>
                        <Row>
                            <Col lg={2} md={2} sm={4} xs={4} className="ws-field">
                                <InputGroup>
                                    <FormControl min={0} type="number" id="team1-score" maxLength="3" placeholder="Runs"
                                        onChange={(e) => setTeam1Score((e.target.value))} />
                                </InputGroup>
                            </Col>
                            <Col lg={2} md={2} sm={4} xs={4} className="ws-field">
                                <InputGroup>
                                    <FormControl min={0} type="number" id="team1-wickets" maxLength="2" placeholder="Wkts"
                                        onChange={(e) => setTeam1Wickets((e.target.value))} />
                                </InputGroup>
                            </Col>
                            <Col lg={2} md={2} sm={4} xs={4} className="ws-field">
                                <InputGroup>
                                    <FormControl min={0} type="number" id="team1-overs" maxLength="4" placeholder="Overs *"
                                        onChange={(e) => setTeam1Overs((e.target.value))} />
                                </InputGroup>
                            </Col>
                        </Row>
                        <div style={{ fontSize: '11px', color: '#888', clear: 'both', marginBottom: '16px' }}>
                            * including penalty
                        </div>
                        <div>Team 2:</div>
                        <Row>
                            <Col lg={2} md={2} sm={4} xs={4} className="ws-field">
                                <InputGroup>
                                    <FormControl min={0} type="number" id="team2-score" maxLength="3" placeholder="Runs"
                                        onChange={(e) => setTeam2Score((e.target.value))} />
                                </InputGroup>
                            </Col>
                            <Col lg={2} md={2} sm={4} xs={4} className="ws-field">
                                <InputGroup>
                                    <FormControl min={0} type="number" id="team2-wickets" maxLength="2" placeholder="Wkts"
                                        onChange={(e) => setTeam2Wickets((e.target.value))} />
                                </InputGroup>
                            </Col>
                            <Col lg={2} md={2} sm={4} xs={4} className="ws-field">
                                <InputGroup>
                                    <FormControl min={0} type="number" id="team2-overs" maxLength="4" placeholder="Overs *"
                                        onChange={(e) => setTeam2Overs((e.target.value))} />
                                </InputGroup>
                            </Col>
                        </Row>
                        <div style={{ fontSize: '11px', color: '#888', clear: 'both', marginBottom: '16px' }}>
                            * including penalty
                        </div>
                        <Button variant="primary" onClick={handleClick}>
                            Show
                        </Button>
                    </div>


                    {!loading &&
                        <Row>
                            <div className="hthRecords sub-section">
                                <h3>
                                    Team 1 WS : <span>{team1WS}</span>
                                </h3>
                                <h3>
                                    Team 2 WS : <span>{team2WS}</span>
                                </h3>
                            </div>
                        </Row>
                    }
                </Col>
            </Row>
        </Container>
    );
};

export default WeightedScoreCalculator;
